<!-- footer section start -->
<footer class="xs-footer-section">
  <div class="container">
    <div class="xs-footer-top-layer">
      <div class="row">
        <div class="col-lg-3 col-md-6 footer-widget xs-pr-20">
          <a href="/" class="xs-footer-logo">
            <img src="/assets/images/footer_logo.png" alt="" />
          </a>
          <p>
            CharityPress online and raise money for charity and causes you’re
            passionate about. CharityPress is an innovative, cost-effective
            online.
          </p>
          <ul class="xs-social-list-v2">
            <li>
              <a href="https://www.facebook.com/" class="color-facebook">
                <i class="fa fa-facebook" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/" class="color-twitter">
                <i class="fa fa-twitter" />
              </a>
            </li>
            <li>
              <a href="https://dribbble.com/" class="color-dribbble">
                <i class="fa fa-dribbble" />
              </a>
            </li>
            <li>
              <a href="https://id.pinterest.com/" class="color-pinterest">
                <i class="fa fa-pinterest" />
              </a>
            </li>
          </ul>
          <!-- .xs-social-list END -->
        </div>
        <div class="col-lg-4 col-md-6 footer-widget">
          <h3 class="widget-title">About Us</h3>
          <ul class="xs-footer-list">
            <li>
              <a href="/">About employee</a>
            </li>
            <li>
              <a href="/">How it works</a>
            </li>
            <li>
              <a href="/">Careers</a>
            </li>
            <li>
              <a href="/">Press</a>
            </li>
            <li>
              <a href="/">Blog</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-6 footer-widget">
          <h3 class="widget-title">Contact Us</h3>
          <ul class="xs-info-list">
            <li>
              <i class="fa fa-home" />
              Sector # 48, 123 Street, miosya road VIC 28, Australia.
            </li>
            <li>
              <i class="fa fa-phone" />
              (800) 123.456.7890 (800) 123.456.7890 +00 99 88 5647
            </li>
            <li>
              <i class="fa fa-github" />
              <a href="https://github.com/ahhzaky">ahhzaky</a>
            </li>
          </ul>

          <!-- .xs-list-with-icon END -->
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="xs-copyright">
      <div class="row">
        <div class="col-md-6">
          <div class="xs-copyright-text">
            <p>&copy; Copyright 2021 Charity. - All Right's Reserved</p>
          </div>
        </div>
        <div class="col-md-6">
          <nav class="xs-footer-menu">
            <ul>
              <li>
                <a href="/">FAQ</a>
              </li>
              <li>
                <a href="/contect">Help Desk</a>
              </li>
              <li>
                <a href="/contect">Support</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div class="xs-back-to-top-wraper">
    <a href="/" class="xs-back-to-top">
      <i class="fa fa-angle-up" />
    </a>
  </div>
</footer>
